<template>
  <!-- MODAL Lighting -->
  <b-modal
    id="Log"
    title="Log"
    size="xl"
    ok-title="ตกลง"
    cancel-title="ยกเลิก"
  >
    <b-col cols="12">
      <template>
        <b-card-code style="background-color: rgb(255, 127, 96, 0.0)">
          <b-row>
            <b-col cols="12">
              <b-table
                responsive
                striped
                hover
                :per-page="perPage"
                :current-page="currentPage"
                :items="items"
                :fields="fields"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                :sort-direction="sortDirection"
                :filter="filter"
                :filter-included-fields="filterOn"
                @filtered="onFiltered"
              />
            </b-col>

            <b-col
              cols="12"
            >
              <b-card-body class="d-flex justify-content-between flex-wrap pt-1">

                <!-- page length -->
                <b-form-group
                  label="Per Page"
                  label-cols="6"
                  label-align="left"
                  label-size="sm"
                  label-for="sortBySelect"
                  class="text-nowrap mb-md-0 mr-1"
                >
                  <b-form-select
                    id="perPageSelect"
                    v-model="perPage"
                    size="sm"
                    inline
                    :options="pageOptions"
                    style="background-color: rgb(255, 127, 96, 0.0)"
                  />
                </b-form-group>

                <!-- pagination -->
                <div>
                  <b-pagination
                    v-model="currentPage"
                    :total-rows="totalRows"
                    :per-page="perPage"
                    first-number
                    last-number
                    prev-class="prev-item"
                    next-class="next-item"
                    class="mb-0"
                  >
                    <template #prev-text>
                      <feather-icon
                        icon="ChevronLeftIcon"
                        size="18"
                      />
                    </template>
                    <template #next-text>
                      <feather-icon
                        icon="ChevronRightIcon"
                        size="18"
                      />
                    </template>
                  </b-pagination>
                </div>
              </b-card-body>
            </b-col>
          </b-row>
        </b-card-code>
      </template>
    </b-col>
  </b-modal>
</template>

<script>
/* eslint-disable global-require */
import {
  BRow, BCol, BTable, BFormGroup,
  BFormSelect, BPagination, BCardBody,
} from 'bootstrap-vue'
import axios from '@axios'
import BCardCode from '@core/components/b-card-code/BCardCode.vue'

export default {
  components: {
    BRow,
    BCol,
    BTable,
    BFormGroup,
    BFormSelect,
    BPagination,
    BCardBody,
    BCardCode,
  },
  data() {
    return {
      items: [],
      fields: [
        {
          key: 'lastupdate', label: 'วัน/เวลา', sortable: true, class: 'text-center box',
        },
        {
          key: 'pwt_name', label: 'ชื่ออุปกรณ์', sortable: true, class: 'text-center box',
        },
        {
          key: 'v1', label: 'Volt1', sortable: true, class: 'text-center box',
        },
        {
          key: 'v2', label: 'Volt2', sortable: true, class: 'text-center box',
        },
        {
          key: 'v3', label: 'Volt3', sortable: true, class: 'text-center box',
        },
        {
          key: 'i1', label: 'Amp1', sortable: true, class: 'text-center box',
        },
        {
          key: 'i2', label: 'Amp2', sortable: true, class: 'text-center box',
        },
        {
          key: 'i3', label: 'Amp3', sortable: true, class: 'text-center box',
        },
      ],
      // --------history--------
      perPage: 100,
      pageOptions: [25, 50, 75, 100],
      totalRows: 1,
      currentPage: 1,
      sortBy: '',
      sortDesc: false,
      sortDirection: 'asc',
      filter: null,
      filterOn: [],
      userData: JSON.parse(localStorage.getItem('userData')),
    }
  },
  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter(f => f.sortable)
        .map(f => ({ text: f.label, value: f.key }))
    },
  },
  beforeDestroy() {
    clearInterval(this.interval)
  },
  mounted() {
    this.getLogScada()
  },
  methods: {
    getLogScada() {
      axios
        .post('/getLog-PWT', { wid: this.$route.query.wid })
        .then(response => {
          this.items = response.data
          this.totalRows = response.data.length
        })
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },
  },
}
</script>

<style lang="scss">
.table-responsive{
    font-size: 14px;
}
.table thead th {
  font-size: 14px;
}
</style>
